module.exports = __webpack_public_path__ + "src/images/SleepingGirl.png";